module.exports = __webpack_public_path__ + "static/img/son2_active.152eaf34.png";